import styles from './styles.module.scss';
import type { Component } from './types';

export const Content: Component = ({
  message,
  title,
  pastCarList,
}) => (
  <div className={styles.containerRoot}>
    <div className={styles.textNoSearchResultTitle}>
      {title}
    </div>
    <div className={styles.textNoSearchResultMessage}>
      {message}
      {pastCarList && pastCarList.length > 0
        ? (
          <>
            <span className={styles.textNoSearchResultPastCarExistMessage}>
              However, there is a model that has been
              {' '}
            </span>
            <span className={styles.textNoSearchResultPastCarExistDate}>
              unavailable since
              {' '}
              {pastCarList[0].endedMonth}
              {' '}
              {pastCarList[0].endedYear}
              .
            </span>
          </>
        )
        : ''}
    </div>
  </div>
);
